import React from 'react';
import { useParams } from 'react-router-dom';
import { activityList } from '../constants/mockData';
import { ChevronLeft, Share2, Heart, Calendar, MapPin, Info, Users, TicketCheck } from 'lucide-react';
import { Button } from '../components/Button';
import { Badge } from '../components/Badge';
export function EventDetail() {
  const {
    id
  } = useParams();
  const event = activityList.find(e => e.id === Number(id)) || activityList[0];
  return <div className="min-h-screen bg-white pb-24" data-id="element-101">
      {/* Hero Header */}
      <div className="relative h-[380px] w-full" data-id="element-102">
        <img src={event.image} alt={event.title} className="w-full h-full object-cover" data-id="element-103" />
        <div className="absolute inset-0 bg-black/20" data-id="element-104" />

        {/* Top Actions */}
        <div className="absolute top-12 left-0 right-0 px-4 flex items-center justify-between z-10" data-id="element-105">
          <button onClick={() => window.history.back()} className="size-10 bg-black/20 backdrop-blur-md rounded-full flex items-center justify-center text-white" data-id="element-106">
            <ChevronLeft className="size-6" data-id="element-107" />
          </button>
          <div className="flex gap-3" data-id="element-108">
            <button className="size-10 bg-black/20 backdrop-blur-md rounded-full flex items-center justify-center text-white" data-id="element-109">
              <Share2 className="size-5" data-id="element-110" />
            </button>
          </div>
        </div>
      </div>

      {/* Content Body */}
      <div className="px-6 -mt-6 relative z-10 bg-white rounded-t-[48rpx] pt-8 flex flex-col gap-8" data-id="element-111">
        <div data-id="element-112">
          <Badge className="bg-orange-500 text-white border-none mb-3" data-id="element-113">
            {event.tag}
          </Badge>
          <h1 className="text-2xl font-bold text-[#333333] leading-tight" data-id="element-114">
            {event.title}
          </h1>
          <p className="text-[#666666] mt-2 text-sm" data-id="element-115">{event.subtitle}</p>
        </div>

        {/* Event Info */}
        <div className="flex flex-col gap-4 bg-gray-50 p-6 rounded-[40rpx]" data-id="element-116">
          <div className="flex items-center gap-4" data-id="element-117">
            <div className="size-10 bg-white rounded-2xl flex items-center justify-center text-[#66CADA] shadow-sm" data-id="element-118">
              <Calendar className="size-5" data-id="element-119" />
            </div>
            <div data-id="element-120">
              <p className="text-[20rpx] text-[#999999]" data-id="element-121">活动时间</p>
              <p className="text-sm font-bold text-[#333333]" data-id="element-122">{event.date}</p>
            </div>
          </div>
          <div className="flex items-center gap-4" data-id="element-123">
            <div className="size-10 bg-white rounded-2xl flex items-center justify-center text-[#66CADA] shadow-sm" data-id="element-124">
              <MapPin className="size-5" data-id="element-125" />
            </div>
            <div data-id="element-126">
              <p className="text-[20rpx] text-[#999999]" data-id="element-127">活动地点</p>
              <p className="text-sm font-bold text-[#333333]" data-id="element-128">
                宿州市各主要景区及文化广场
              </p>
            </div>
          </div>
          <div className="flex items-center gap-4" data-id="element-129">
            <div className="size-10 bg-white rounded-2xl flex items-center justify-center text-[#66CADA] shadow-sm" data-id="element-130">
              <Users className="size-5" data-id="element-131" />
            </div>
            <div data-id="element-132">
              <p className="text-[20rpx] text-[#999999]" data-id="element-133">推荐人群</p>
              <p className="text-sm font-bold text-[#333333]" data-id="element-134">
                全体市民及来宿游客
              </p>
            </div>
          </div>
        </div>

        {/* Description */}
        <div className="flex flex-col gap-3" data-id="element-135">
          <h2 className="text-xl font-bold text-[#333333]" data-id="element-136">活动介绍</h2>
          <p className="text-[#666666] leading-relaxed text-sm" data-id="element-137">
            本次活动是宿州文旅通重点打造的年度盛事，旨在通过丰富多彩的文化展示和互动体验，让每一位参与者都能深度感受宿州的独特魅力。活动期间将举办多场非遗表演、美食品鉴及文创市集。
          </p>
        </div>
      </div>

      {/* Bottom Sticky Actions */}
      <div className="fixed bottom-0 left-0 right-0 h-24 bg-white border-t border-gray-100 px-6 flex items-center gap-4 z-50" data-id="element-138">
        <div className="flex flex-col items-center gap-1 text-[#999999] px-2" data-id="element-139">
          <Heart className="size-5" data-id="element-140" />
          <span className="text-[18rpx]" data-id="element-141">收藏</span>
        </div>
        <Button className="flex-1 bg-[#66CADA] hover:bg-[#2BAABD] text-white rounded-full py-6 font-bold text-lg shadow-lg shadow-[#66CADA]/20" data-id="element-142">
          <TicketCheck className="size-5 mr-2" data-id="element-143" />
          立即报名
        </Button>
      </div>
    </div>;
}